export { default } from './modules/ReactTimeAgo';